export const getRandomElements = <T>(array: T[], maxElements: number): T[] => {
  if (!array || array.length === 0) return [];

  const shuffled = [...array];
  for (let currentIndex = shuffled.length - 1; currentIndex > 0; currentIndex--) {
    const randomIndex = Math.floor(Math.random() * (currentIndex + 1));
    [shuffled[currentIndex], shuffled[randomIndex]] = [
      shuffled[randomIndex],
      shuffled[currentIndex],
    ];
  }

  return shuffled.slice(0, Math.min(maxElements, shuffled.length));
};
